module.exports = __webpack_public_path__ + "static/media/sparrow-lansing.0cbcb079.png";